import { http } from './http';

export interface ImportIcResult {
  DocumentId?: number;
  documentId?: number;
}

export interface ImportIcRequest {
  drawerName: string;
  file: File;
  doctype: string;
  documentDescription: string;
  folderId?: number | null;
  subfoldername?: string | null;
  fieldValues?: Record<string, any>;
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  // Convert in chunks to avoid stack/arg limits on large files
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  let binary = '';
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode(...chunk);
  }
  return btoa(binary);
}

export class ImportIcClient {
  static async importFile(req: ImportIcRequest): Promise<number> {
    if (!req.drawerName) throw new Error('DrawerName is required');
    if (!req.doctype) throw new Error('Document type is required');
    if (!req.file) throw new Error('File is required');

    const buf = await req.file.arrayBuffer();
    const fileBase64 = arrayBufferToBase64(buf);

    // Match OfficeAddins/AddinShared/DynamicArchiveForm.cs payload shape
    const payload: Record<string, any> = {
      DrawerName: req.drawerName,
      documentdescription: req.documentDescription || req.file.name,
      FileName: req.file.name,
      FileBase64: fileBase64,
      doctype: req.doctype
    };

    if (req.folderId != null) payload.FolderId = req.folderId;
    if (req.subfoldername) payload.subfoldername = req.subfoldername;

    if (req.fieldValues) {
      for (const [k, v] of Object.entries(req.fieldValues)) payload[k] = v;
    }

    const res = await http<ImportIcResult>('/api/import/ImportIC', { method: 'POST', json: payload });
    const id = Number((res as any)?.DocumentId ?? (res as any)?.documentId);
    if (!Number.isFinite(id) || id <= 0) throw new Error('Import did not return a DocumentId');
    return id;
  }
}
